module.exports = __webpack_public_path__ + "img/52.e20532d2.jpg";